"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var styles = {
  "sticky": "styles-sticky-3tUpM",
  "head-cell": "styles-head-cell-y0nGZ",
  "sortable": "styles-sortable-1hV1a",
  "asc": "styles-asc-1uDJb",
  "desc": "styles-desc-3B49S",
  "headCell": "styles-head-cell-y0nGZ"
};

/**
 * Simple table cell component.
 *
 * Allows to have sticky cells.
 */
var Cell = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      sticky = _ref.sticky,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'td' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "sticky", "className", "tag"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    className: _utils.classNames.use({
      sticky: sticky
    }).from(styles).join(className),
    ref: ref
  }, restProps), children);
});

Cell.propTypes = {
  sticky: _propTypes["default"].bool
};
Cell.defaultProps = {
  sticky: false
};
var _default = Cell;
exports["default"] = _default;